import { Component, OnInit } from '@angular/core';
import { first } from "rxjs/operators";
import { LigneFinancement } from 'src/app/parametrage/core/model/ligneFinancement/ligneFinancement';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LigneFinancementService } from 'src/app/parametrage/core/service/ligne-financement/ligne-financement.service';

@Component({
  selector: "app-add-ligne-financement",
  templateUrl: "./add-ligne-financement.component.html",
  styleUrls: ["./add-ligne-financement.component.scss"]
})
export class AddLigneFinancementComponent implements OnInit {
  dateDebut: any;
  dateFin: any;

  ligneFinancement: LigneFinancement = new LigneFinancement();

  form2: FormGroup;
  pressButton: Boolean = false;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _ligneFinancementService: LigneFinancementService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      code: [null, Validators.compose([Validators.required])],
      montant: [null, Validators.compose([Validators.nullValidator])],
      libelle: [null, Validators.compose([Validators.required])],
      dateDebut: [null, Validators.compose([Validators.required])],
      dateFin: [null, Validators.compose([Validators.required])]
    });
  }

  ngOnInit() {}

  save(): void {

    this.pressButton = true;
    this.ligneFinancement = this.form2.value;

    if (this.dateDebut) {
      const formattedDate = `${this.dateDebut.year}-${String(
        this.dateDebut.month
      ).padStart(2, "0")}-${String(this.dateDebut.day).padStart(2, "0")}`;
      this.ligneFinancement.dateDebut = formattedDate;
    }

    if (this.dateFin) {
      const formattedDate2 = `${this.dateFin.year}-${String(
        this.dateFin.month
      ).padStart(2, "0")}-${String(this.dateFin.day).padStart(2, "0")}`;
      this.ligneFinancement.dateFin = formattedDate2;
    }

    this._ligneFinancementService
      .add(this.ligneFinancement)
      .pipe(first())
      .subscribe(
        data => {
          this.pressButton = false;
          this.activeModal.close();
        },
        error => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }
}
